import { gql } from "urql";

export const GET_BOOKED_DATES = gql`
    query GetBookedDates {
        bookedDates: fetchFullyBookedDates
    }
`;

export const GET_BOOKED_TIMES = gql`
    query GetBookedTimes($date: String!) {
        bookedTimes: fetchBlockedTimes(date: $date)
    }
`;